module.exports = __webpack_public_path__ + "static/media/M112ws.58de38ff.pdf";